<div class="ui-g-12 download-title" translate>DOWNLOAD.TITLE</div>
<div class="ui-g-12">
    <p translate>DOWNLOAD.APPLINK</p>
    <p translate>DOWNLOAD.WININSTALL</p>
    <p translate>DOWNLOAD.OSXINSTALL</p>
</div>
<div *ngIf="ds.mobile" class="ui-lg-2"></div>
<div class="ui-g-12 ui-lg-3 text-center">
    <div class="ui-g-12">
        <a href="http://www.keystonekubb.com/updates/klassic/TournamentDirector_install.exe" target="_blank">
            <img width="50" height="50" src="assets/images/windows.png" />
        </a> 
    </div>
    <div class="ui-g-12">
        <a href="http://www.keystonekubb.com/updates/klassic/TournamentDirector_install.exe" target="_blank" translate>DOWNLOAD.WININFO</a>
    </div>
</div>
<div class="ui-g-12 ui-lg-3 text-center">
    <div class="ui-g-12">
        <a href="http://www.keystonekubb.com/updates/klassic/TournamentDirector.dmg" target="_blank">
            <img width="50" height="50" src="assets/images/osx.png" /> 
        </a>
    </div>
    <div class="ui-g-12">
        <a href="http://www.keystonekubb.com/updates/klassic/TournamentDirector.dmg" target="_blank" translate>DOWNLOAD.OSXINFO</a>
    </div>
</div>